<script lang="ts" setup>
import { ref } from 'vue';
import { Chart, ArcElement, Tooltip, Title, ChartData } from 'chart.js';
import { DoughnutChart } from 'vue-chart-3';
import { computed } from 'vue';

// Chart.jsのコンポーネントを登録
Chart.register(ArcElement, Tooltip, Title);

// props
const props = withDefaults(
  defineProps<{
    progress?: number;
  }>(),
  {
    progress: 0,
  } // 初期値設定
);

/**
 * チャートデータ
 * おもて部分のグラフデータ(進捗率)
 * 取引件数によって進捗率の受け入れタイミングが変わるのでcomputedで管理する
 */
const displayChartData = computed(() => {
  return createMainChartData(props.progress);
});

/**
 * 進捗率を表すチャートデータを作成する
 * @param progress -
 */
const createMainChartData = (progress: number): ChartData<'doughnut'> => {
  return {
    labels: ['progress', 'diff'], // データラベル(正味いらない)
    datasets: [
      {
        data: [progress, 100 - progress],
        backgroundColor: ['#64b5f6', 'transparent'],
        borderColor: ['#64b5f6', 'transparent'],
        borderRadius: 15,
      },
    ],
  };
};

// 背面部分のチャートデータを作成する(進捗の残り部分を表現する用)
const backgroundChartData = ref<ChartData<'doughnut'>>({
  datasets: [
    {
      data: [100],
      backgroundColor: ['#eeeeee'],
      borderColor: ['#eeeeee'],
    },
  ],
});

// // チャートのデザインなどのオプションを定義
const mainChartOptions = ref({
  responsive: true,
  cutout: '80%', // 円グラフの太さ
  // オプション項目
  plugins: {
    legend: {
      display: false,
    },
    tooltip: false,
  },
});

/**
 * 背面に設置しているチャートのデザインなどのオプションを定義
 */
const backgroundChartOptions = ref({
  responsive: true,
  cutout: '80%', // 円グラフの太さ
  // アニメーション
  animation: {
    animateRotate: false,
    animateScale: false,
  },
  // オプション項目
  plugins: {
    legend: {
      display: false,
    },
    tooltip: false,
  },
});

// ドーナツチャートの中央に進捗率を表示させるプラグインを定義
const ratioText = ref({
  id: 'ratioText',
  /**
   * 描画操作
   * @param chart - グラフ情報
   */
  beforeDraw(chart: any) {
    const {
      ctx,
      chartArea: { top, width, height },
    } = chart;
    ctx.save();
    //チャート描画部分の中央を指定
    ctx.fillRect(width / 2, top + height / 2, 0, 0);
    //フォントのスタイル指定
    ctx.font = 'bold 22px Roboto';
    ctx.fillStyle = '#1e92ef';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    //進捗率文字列をドーナツチャートの中央部に描画する
    ctx.fillText(`${props.progress}%`, width / 2, top + height / 1.9);
  },
});
</script>

<template>
  <div class="round-progress-bar-container">
    <!-- グラフを二つ重ねてプログレスバーを無理やり表現 -->
    <DoughnutChart :chart-data="backgroundChartData" :options="backgroundChartOptions" />
    <DoughnutChart :class="'main-round-progress-bar'" :chart-data="displayChartData" :options="mainChartOptions" :plugins="[ratioText]" />
  </div>
</template>

<style lang="scss" scoped>
.round-progress-bar-container {
  height: 81%;
  width: 81%;
  margin: auto;
  position: relative;
}
.main-round-progress-bar {
  position: absolute !important;
  top: 0%;
  left: 0%;
}
</style>
